<mat-form-field>
  <mat-label>{{ label() || 'Select an option' }}</mat-label>
  <mat-icon matPrefix>{{prefixIcon()}}</mat-icon>
  <input type="text" [name]="label()" matInput [formControl]="myControl" [matAutocomplete]="auto" [placeholder]="placeholder()">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    @for (option of filteredOptions | async; track option) {
    <mat-option [value]="option" (onSelectionChange)="onOptionSelected(option)"><div [hidden]="!isDisplayColorOption()" class="option-color" [style.backgroundColor]="generateColorFromString(option.name.toLowerCase())"></div><span>{{option.name}}</span></mat-option>
    }
  </mat-autocomplete>
</mat-form-field>